/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Inject, Injectable} from '@angular/core';
import * as _ from 'lodash';
import {WINDOW} from '../angular-platform-providers';
import {Downloader} from '../../components/util/downloader';
import {formatCsvOutput} from '../common/filters/csv-output';
import {PaymentModel} from './payment-api.service';
import {escapeCsvValue} from '../common/util/csv-value';

const BASE_TITLE = 'payments';
const CSV_COLUMNS = ['createTime', 'provider', 'status', 'statusTimestamp', 'amount', 'billedAmount', 'refundedAmount', 'receiptUrl', 'appliedCouponName', 'appliedCouponId', 'couponDiscountAmount', 'lineItemName', 'lineItemId'];
const CSV_HEADINGS = ['Payment Time', 'Payment Service', 'Status', 'Status Date', 'Budgeted Amount', 'Billed Amount', 'Refunded Amount', 'Receipt URL', 'Coupon', 'Coupon ID', 'Coupon Amount', 'Line Item', 'Line Item ID'];
const ADJUSTMENT_COLUMNS = {
  appliedCouponId: ['appliedCoupon', 'id'],
  appliedCouponName: ['appliedCoupon', 'name'],
  lineItemName: ['lineItem', 'name'],
  lineItemId: ['lineItem', 'id']
};


export function paymentExportRows(payments: PaymentModel[]): any[] {
  return _.cloneDeep(payments).map((payment) => {
    const row: any = payment;
    _.forEach(ADJUSTMENT_COLUMNS, (path, key) => row[key] = _.get(payment, path));
    CSV_COLUMNS.forEach((column) => row[column] = formatCsvOutput(row[column], column));
    return row;
  });
}

export function paymentCsv(payments: PaymentModel[]): string {
  const header = CSV_HEADINGS.map(escapeCsvValue).join(',');
  const body = paymentExportRows(payments).map((row) => CSV_COLUMNS.map((column) => escapeCsvValue(row[column])).join(',')).join('\r\n');
  return '\uFEFF' + header + '\r\n' + body;
}

@Injectable({providedIn: 'root'})
export class PaymentExportService {
  constructor(@Inject(WINDOW) private readonly window: Window & typeof globalThis) {}

  saveXls(payments: PaymentModel[]): Promise<void> {
    return new Downloader().saveXls2(BASE_TITLE + '.xls', CSV_HEADINGS, CSV_COLUMNS, paymentExportRows(payments), []);
  }

  saveCsv(payments: PaymentModel[]): void {
    const url = this.window.URL.createObjectURL(new Blob([paymentCsv(payments)], {type: 'text/csv;charset=utf-8;'}));
    const link = this.window.document.createElement('a');
    link.href = url;
    link.download = BASE_TITLE + '.csv';
    this.window.document.body.appendChild(link);
    try { link.click(); } finally {
      link.remove();
      this.window.URL.revokeObjectURL(url);
    }
  }
}
